<bn-loading-overlay></bn-loading-overlay>

<div class="container" *ngIf="controleAgendamentoProcessoHonraBatch; else carregando">

    <div class="row">
        <div class="col">
            <h3>
                Detalhes de execução da rotina batch
                <small *ngIf="controleAgendamentoProcessoHonraBatch.id" class="text-muted">(#ID: {{ controleAgendamentoProcessoHonraBatch.id }})</small>
            </h3>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary" (click)="voltarParaLista()">Voltar</button>
        </div>
    </div>

    <div class="row">
        <div class="bn-form-group col-md-8">
            <label><b>Rotina:</b></label>
            <input type="text" class="form-control" name="nomeProcessoBatchHonra" value="{{controleAgendamentoProcessoHonraBatch.nomeProcessoBatchHonra}}" disabled>
        </div>
    </div>
    <div class="row">
        <div class="bn-form-group col-md-4">
            <label><b>Janela de envio das solicitações de honra:</b></label>
            <input type="text" class="form-control" name="nomeProcessoBatchHonra" value="{{controleAgendamentoProcessoHonraBatch.anoMesJanela}}" disabled>
        </div>
    </div>
        
    <div class="row">
        <div class="bn-form-group col-md-4">

            <label><b>Data prevista da primeira execução:</b></label>
            <input type="text" class="form-control" name="nomeProcessoBatchHonra" value="{{controleAgendamentoProcessoHonraBatch.dataPrevistaParaPrimeiraExecucao | date:'dd/MM/yyyy'}}"  disabled>
        </div>
        <div class="bn-form-group col-md-4">
            <label><b>Data prevista da última execução:</b></label>
            <input type="text" class="form-control" name="nomeProcessoBatchHonra" value="{{controleAgendamentoProcessoHonraBatch.dataPrevistaParaUltimaExecucao | date:'dd/MM/yyyy'}}" disabled>
        </div>
    </div>
    <div class="row">
        <div class="bn-form-group col-md-4">
            <label><b>Data de execução excepcional:</b></label>
            <input type="text" class="form-control" name="nomeProcessoBatchHonra" value="{{controleAgendamentoProcessoHonraBatch.dataExecucaoExcepcional | date:'dd/MM/yyyy'}}" disabled>
        </div>
    </div>
   
    <br/>

    <h5>Log das execuções realizadas</h5>
    <div class="table-responsive">
        <table class="table table-hover">
            <thead>
                <tr>
                    <th scope="col">Data de referência da execução</th>
                    <th scope="col">Execução realizada com sucesso</th>
                    <th scope="col">Tempo total de execução</th>
                <tr>
            </thead>
            <tbody>
                <tr *ngFor="let logExecucao of controleAgendamentoProcessoHonraBatch.logsExecucao">
                    <td>{{ logExecucao.dataReferenciaExecucao | date:'dd/MM/yyyy H:mm'}}</td>
                    <td>{{ logExecucao.execucaoRealizadaComSucesso == true? 'Sim' : 'Não' }}</td>
                    <td>{{ logExecucao.tempoTotalEmSegundos | timeFormat }}</td>
                </tr>
            </tbody>
        </table>
    </div>

</div>

<ng-template #carregando>
    <div class="loading-pesquisa">
        <i class="bn-loading"></i>
    </div>
</ng-template>
